import React from 'react';
import { useNavigate } from 'react-router-dom';
import Pill from '../../shared/components/Pill';
import { MdWorkspacePremium } from '../../shared/icons';
import { useSubscription } from './useSubscription';

/**
 * Header plan pill — TIME-LIMITED PREMIUM ONLY: the 7-day full-access preview
 * (accounts created before 1.5.0) and the 30-day referral pass.
 *
 * A permanent "Free" pill in the header is a nag in prime space with no
 * information for the user; plan state lives on /more and /settings instead
 * (both link to /subscription). This badge exists purely to make the remaining
 * time of a preview or a pass visible while it is running.
 *
 * Never call either a "free trial" — that phrase belongs only to Apple's
 * introductory offer on the plans themselves.
 */
export default function PlanBadge() {
  const { isPreview, previewEndsAt, isPass, passEndsAt, isLoading } = useSubscription();
  const navigate = useNavigate();

  if (isLoading || (!isPreview && !isPass)) return null;

  const endsAt = isPass ? passEndsAt : previewEndsAt;
  const label = isPass ? 'Pass' : 'Preview';
  const spoken = isPass ? 'Premium pass' : 'Preview';
  const daysLeft = endsAt ? Math.max(1, Math.ceil((new Date(endsAt) - Date.now()) / 86400000)) : null;

  return (
    <Pill
      as="button"
      size="md"
      tone="primary"
      icon={MdWorkspacePremium}
      onClick={() => navigate('/subscription')}
      aria-label={
        daysLeft
          ? `${spoken}, ${daysLeft} day${daysLeft === 1 ? '' : 's'} left. View subscription`
          : `${spoken}. View subscription`
      }
    >
      {daysLeft ? `${label} · ${daysLeft}d` : label}
    </Pill>
  );
}
